/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Signed_Out_NoteInputs */



/**
* | output |
* | --- |
* | "Sign in to send us a message. Your account tells us who to reply to." |
*
* @param {Support_Signed_Out_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const support_signed_out_note = /** @type {((inputs?: Support_Signed_Out_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Signed_Out_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Melde dich an, um uns eine Nachricht zu senden. Über dein Konto wissen wir, wem wir antworten.")
	return /** @type {LocalizedString} */ ("Sign in to send us a message. Your account tells us who to reply to.")
});